// Copyright 2025 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import {createButton} from "react-social-login-buttons";

// Matrix logo from Simple Icons CDN (green #0DBD8B)
const matrixLogoDataUrl = "https://cdn.simpleicons.org/matrix/0DBD8B";

function Icon({width = 24, height = 24, color}) {
  return <img src={matrixLogoDataUrl} alt="Sign in with Matrix" style={{width: 24, height: 24}} />;
}

const config = {
  text: "Sign in with Matrix",
  icon: Icon,
  iconFormat: name => `fa fa-${name}`,
  style: {background: "#0dbd8b", color: "#ffffff"},
  activeStyle: {background: "#0aa87d"},
};

const MatrixLoginButton = createButton(config);

export default MatrixLoginButton;
